// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileImageTwoToneSvg from "@fishx/icons-svg/es/asn/FileImageTwoTone";
import FishxIcon from '../components/FishxIcon';

var FileImageTwoTone = function FileImageTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileImageTwoToneSvg
  }));
};

FileImageTwoTone.displayName = 'FileImageTwoTone';
export default React.forwardRef(FileImageTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileImageTwoTone.js
// module id = 2709
// module chunks = 0